import * as types from './actionTypes';

export function closeReportToast() {
  return {
    type: types.CLOSE_REPORT_TOAST,
  };
}

export function openReportToast(payload) {
  return {
    type: types.OPEN_REPORT_TOAST,
    payload,
  };
}

export function updateReportToast(payload) {
  return {
    type: types.UPDATE_REPORT_TOAST,
    payload,
  };
}

export function setDownloadingStatus(isDownloading) {
  return {
    type: types.SET_DOWNLOADING_STATUS,
    payload: { isDownloading },
  };
}

export function startReportPolling(payload) {
  return {
    type: types.START_REPORT_POLLING,
    payload,
  };
}

export function stopReportPolling() {
  return {
    type: types.STOP_REPORT_POLLING,
  };
} 